const StLuciaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112455)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#338AF3"
      />
      <path d="M12.6084 26.9567H27.3911L19.9997 9.56543L12.6084 26.9567Z" fill="#F3F3F3" />
      <path d="M15.1777 25.2165L20.0003 14.2471L24.8229 25.2165H15.1777Z" fill="#333333" />
      <path d="M12.6084 26.9565H27.3911L19.9997 20L12.6084 26.9565Z" fill="#FFDA44" />
    </g>
    <defs>
      <clipPath id="clip0_4152_112455">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default StLuciaSvg;
